import React from 'react';
import styled from '@emotion/styled';
import { useMutation } from '@apollo/client';
import gql from 'graphql-tag';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import State from '~Types/state';
import * as actions from '../../../actions';
import _ from 'lodash';
import { User } from '~Types';
import { useBridgeApi, useI18n, useLogger } from '~Hooks';
import { Button } from '~Styles';
import { removeDeviceToken, removeDeviceTokenVariables } from './__queries__';

const REMOVE_DEVICE_TOKEN = gql`
  mutation removeDeviceToken($token: String!) {
    removeDeviceToken(token: $token) {
      success
      message
    }
  }
`;

const LogoutLinkContainer = styled(Button)`
  background-color: var(--colorUIRed);
`;

const LogoutLink = styled(Link)`
  display: block;
  text-align: center;
  color: #fff;
  text-decoration: none;
`;

interface Props {
  setToken: (token: string | null) => void;
  deviceId: string;
  setUser: (user: User | null) => void;
}

const Logout: React.FunctionComponent<Props> = ({ setToken, deviceId, setUser }) => {
  const { i18n } = useI18n();
  const bridgeApi = useBridgeApi();
  const reloadLogger = useLogger('mount');
  const [removeDeviceToken] = useMutation<removeDeviceToken, removeDeviceTokenVariables>(
    REMOVE_DEVICE_TOKEN,
  );

  const logout = () => {
    if (deviceId) {
      removeDeviceToken({
        variables: {
          token: deviceId,
        },
      });
    }
    setToken(null);
    setUser(null);
    window.postMessageBridge({
      setGalaxyToken: false,
      galaxyToken: '',
    });
    window.postMessageReact('authToken:');

    reloadLogger.info('Location reload: logout');

    setTimeout(() => {
      bridgeApi.reload();

      window.location.reload();
    }, 500);
  };

  return (
    <LogoutLinkContainer>
      <LogoutLink to="/" onClick={logout}>
        {i18n('Menu.Logout')}
      </LogoutLink>
    </LogoutLinkContainer>
  );
};
const mapStateToProps = (state: State) => ({
  deviceId: state.deviceId,
});

const mapDispatchToProps = {
  setUser: actions.setUser,
  setToken: actions.setToken,
};

export default _.flowRight(connect(mapStateToProps, mapDispatchToProps))(Logout);
